import React from "react";
import Table from "react-bootstrap/Table";
import { VscFilePdf } from "react-icons/vsc";

const PensionAmount = ({ spinner, date, incomeData, setShow, t, toast }) => {
  return (
    <div className="w-100 mt-4 table-div">
      <Table striped bordered hover>
        <thead>
          <tr>
            <th className="invoice_tabeletext">
              {spinner.spinner && date.from && date.to
                ? t("Loading Pension Amount")
                : spinner.spinner
                ? `${t("Loading Pension Amount For ")} ${spinner.Year}`
                : date.from || date.to
                ? `${t("Pension Amount")}`
                : `${t("Pension Amount")}`}
            </th>
            <th className="invoice_tabeletext" style={{ minWidth: "52px" }}>
              {t("Action")}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="semester">
              <span className="font-weight-bold"> {t("Balance Left")} </span>

              {spinner.spinner ? (
                <div
                  className="spinner-border text-primary spinner-border-sm"
                  role="status"
                >
                  <span className="sr-only">Loading...</span>
                </div>
              ) : (date.from || date.to) && !incomeData.usingDates ? (
                t("Please select the dates and click on the download button")
              ) : incomeData.values?.pensionAmount ? (
                incomeData.values?.pensionAmount + " SEK"
              ) : incomeData.statusCode === 400 ? (
                t("Found an Error")
              ) : incomeData.statusCode === 200 &&
                !incomeData.values?.pensionAmount ? (
                t("No data found")
              ) : (
                t("Click Download to see data")
              )}
            </td>

            <td>
              <div className="pdfIcon">
                <VscFilePdf
                  title={t("Download PDF")}
                  onClick={() => {
                    if (
                      incomeData.statusCode === 200 &&
                      incomeData.values &&
                      incomeData.values.pensionAmount
                    ) {
                      setShow({ PDFModal: true });
                    } else if (incomeData.statusCode === 200) {
                      toast.error(t(`${t("No data found")}`));
                    } else {
                      toast.error(
                        t(
                          "Please click the download button to download the data"
                        )
                      );
                    }
                  }}
                  size={30}
                />
              </div>
            </td>
          </tr>
        </tbody>
      </Table>
    </div>
  );
};

export default PensionAmount;
